import { useCallback, useRef } from 'react'
import { matchPath, useLocation } from 'react-router-dom'
import { ZaiChatAccessProvider } from '@winnin/zai-chat'

import { useZaiBackgroundNotification } from 'modules/zai/zai-background-notification'
import { PATHNAMES } from 'utils/routes/consts'

import type {
  TZaiChatAccessProviderMiddlewareProps,
  TZaiSwitchToThread,
} from './zai-chat-access-provider-middleware.types'

export const ZaiChatAccessProviderMiddleware = ({
  children,
  ...accessProps
}: TZaiChatAccessProviderMiddlewareProps) => {
  const { pathname } = useLocation()
  const switchToThreadRef = useRef<TZaiSwitchToThread>()

  const setAssistantUiControl = useCallback((switchToThread: TZaiSwitchToThread) => {
    switchToThreadRef.current = switchToThread
  }, [])

  const isChatVisible = useCallback(() => Boolean(matchPath(pathname, { path: PATHNAMES.WORKSPACE_ZAI })), [pathname])

  const { notifyBackgroundThreadComplete } = useZaiBackgroundNotification(switchToThreadRef, isChatVisible)

  return (
    <ZaiChatAccessProvider
      {...accessProps}
      onBackgroundThreadComplete={notifyBackgroundThreadComplete}
      setAssistantUiControl={setAssistantUiControl}
      isChatVisible={isChatVisible}
    >
      {children}
    </ZaiChatAccessProvider>
  )
}
